(function () {
  window.initHaircareLp = function () {
    var $ = window.jQuery;
    if (!$ || typeof $.fn.on !== 'function') {
      console.error('[LP] jQuery is required for initHaircareLp');
      return;
    }
    function bindLoad(fn) {
      var run = function () {
        try { fn(); } catch (e) { console.warn('[LP] initHaircareLp bindLoad', e); }
      };
      if (document.readyState === 'complete') run();
      else $(window).on('load', run);
    }
    function safeTop(target) {
      try {
        var $el = target && target.jquery ? target : $(target);
        if (!$el || !$el.length) return 0;
        var o = $el.offset();
        return o ? o.top : 0;
      } catch (e) {
        return 0;
      }
    }
    function initStepSlider($root, opts) {
      var $list = $root.find('ul.ss-slider');
      if (!$list.length || $list.hasClass('slick-initialized')) return null;
      var slideCount = $list.children().length;
      var show = Math.min(opts.slidesToShow || 3, Math.max(slideCount, 1));
      var slick = $list.slick({
        slidesToShow: show,
        slidesToScroll: 1,
        arrows: false,
        swipe: true,
        infinite: slideCount > show,
        dots: true,
        autoplay: false,
        autoplaySpeed: 5000,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '17vw'
            }
          }
        ]
      });
      $root.find('.slick-next').off('click.lpHair').on('click.lpHair', function () {
        slick.slick('slickNext');
      });
      $root.find('.slick-prev').off('click.lpHair').on('click.lpHair', function () {
        slick.slick('slickPrev');
      });
      $list.find('.text, .img, .name-and-price').matchHeight();
      return slick;
    }

    function initStepItemSlider(listSelector, nextSelector, prevSelector) {
      var $list = $(listSelector);
      if (!$list.length || $list.hasClass('slick-initialized')) return null;
      var slick = $list.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipe: true,
        infinite: true,
        dots: true,
        autoplay: false,
        autoplaySpeed: 5000,
        responsive: [
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              centerPadding: '10vw'
            }
          }
        ]
      });
      $(nextSelector).off('click.lpHair').on('click.lpHair', function () {
        slick.slick('slickNext');
      });
      $(prevSelector).off('click.lpHair').on('click.lpHair', function () {
        slick.slick('slickPrev');
      });
      return slick;
    }

    /* --- block 1: STEP1 ss1 --- */
    (function () {
      try {
        initStepSlider($('#hc .step-slider.ss1'), { slidesToShow: 3 });
      } catch (e) { console.warn('[LP] initHaircareLp block 1', e); }
    })();

    /* --- block 2 --- */
    (function () {
      try {

                                  $("#howto1-play").click(function () {
                                      $(this).toggleClass('hide');
                                      if ($('#howto1')[0].paused) {
                                        $('#howto1')[0].play();
                                      } else {
                                        $('#howto1')[0].pause();
                                      }
                                    });
      } catch (e) { console.warn('[LP] initHaircareLp block 2', e); }
    })();

    /* --- block 3 --- */
    (function () {
      try {

                                  $("#howto2-play").click(function () {
                                      $(this).toggleClass('hide');
                                      if ($('#howto2')[0].paused) {
                                        $('#howto2')[0].play();
                                      } else {
                                        $('#howto2')[0].pause();
                                      }
                                    });
      } catch (e) { console.warn('[LP] initHaircareLp block 3', e); }
    })();

    /* --- block 4 --- */
    (function () {
      try {

                                  $("#howto3-play").click(function () {
                                      $(this).toggleClass('hide');
                                      if ($('#howto3')[0].paused) {
                                        $('#howto3')[0].play();
                                      } else {
                                        $('#howto3')[0].pause();
                                      }
                                    });
      } catch (e) { console.warn('[LP] initHaircareLp block 4', e); }
    })();

    /* --- block 5 --- */
    (function () {
      try {

                                  $("#howto4-play").click(function () {
                                      $(this).toggleClass('hide');
                                      if ($('#howto4')[0].paused) {
                                        $('#howto4')[0].play();
                                      } else {
                                        $('#howto4')[0].pause();
                                      }
                                    });
      } catch (e) { console.warn('[LP] initHaircareLp block 5', e); }
    })();

    /* --- block 6 --- */
    (function () {
      try {
var howtouse_swiper = new Swiper('.howtouse .howtouse-swiper', {
                            slidesPerView: 1,
                            spaceBetween: 29,
                            grabCursor: true,
                            scrollbar: {
                              el: '.howtouse .howtouse-swiper .swiper-scrollbar',
                              draggable: true,
                            },
                            breakpoints: {
                              320: {
                                slidesPerView: 1,
                              },
                              960: {
                                slidesPerView: 'auto',
                              },
                            },
                            on: {
                              beforeTransitionStart: (swiper) => {
                                $('.howtouse .howtouse-scroll').hide();
                              },
                            },
                          });
                          $(".howtouse .howtouse-swiper").click(function () {
                            $('.howtouse .howtouse-scroll').hide();
                          });
      } catch (e) { console.warn('[LP] initHaircareLp block 6', e); }
    })();

    /* --- block 7: STEP2 repair shampoo slider --- */
    (function () {
      try {
        initStepItemSlider(
          '#hc .step-item-slider .step__list.step__list--2',
          '#hc .step-item-slider .slick-next--step2',
          '#hc .step-item-slider .slick-prev--step2'
        );
      } catch (e) { console.warn('[LP] initHaircareLp block 7', e); }
    })();

    /* --- block 8: STEP2 ss2 --- */
    (function () {
      try {
        initStepSlider($('#hc .step-slider.ss2'), { slidesToShow: 3 });
      } catch (e) { console.warn('[LP] initHaircareLp block 8', e); }
    })();

    /* --- block 9: STEP3 repair mask slider --- */
    (function () {
      try {
        initStepItemSlider(
          '#hc .step-item-slider .step__list.step__list--3',
          '#hc .step-item-slider .slick-next--step3',
          '#hc .step-item-slider .slick-prev--step3'
        );
      } catch (e) { console.warn('[LP] initHaircareLp block 9', e); }
    })();

    /* --- block 10: STEP3 conditioner slider --- */
    (function () {
      try {
        initStepItemSlider(
          '#hc .step-item-slider .step__list.step__list--4',
          '#hc .step-item-slider .slick-next--step4',
          '#hc .step-item-slider .slick-prev--step4'
        );
      } catch (e) { console.warn('[LP] initHaircareLp block 10', e); }
    })();

    /* --- block 11 --- */
    (function () {
      try {
var slick_other = $('.other-kit-slider .other-kit__list').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                swipe: true,
                infinite: true,
                dots: true,
                autoplay: true,
                autoplaySpeed: 5000,
                responsive: [
                  {
                    breakpoint: 960,
                    settings: {
                      slidesToShow: 1,
                      centerMode: true,
                      centerPadding: '17vw'
                    }
                  },
                ]
              });

              $('.other-kit-slider .slick-next').on('click', function () {
                slick_other.slick('slickNext');
              });
              $('.other-kit-slider .slick-prev').on('click', function () {
                slick_other.slick('slickPrev');
              });

              $('.other-kit-slider ul li .other-kit__catch').matchHeight();
              $('.other-kit-slider ul li .img').matchHeight();
              $('.other-kit-slider ul li .name-and-price').matchHeight();
      } catch (e) { console.warn('[LP] initHaircareLp block 11', e); }
    })();

    /* --- block 12 --- */
    (function () {
      try {
$("#hc .faq .faq-list dl > dt > a").on("click", function () {
                    $(this).toggleClass("open");
                    $(this).parent().next("dd").slideToggle(500);

                  });
      } catch (e) { console.warn('[LP] initHaircareLp block 12', e); }
    })();

    /* --- block 13 --- */
    (function () {
      try {
$('.inview').css('opacity', 0);
              $('.inview').one('inview', function (event, isInView) {
                if (isInView) {
                  $(this).delay(300).queue(function () {
                    $(this).stop().animate({ opacity: 1 }, 500);
                  });
                }
              });

              $(".pagetop a").click(function () {
                $("html,body").animate({ scrollTop: 0 }, 600);
              });

              $(window).on('load scroll', function () {

                var pl = $(this).scrollTop();
                if (pl == 0) {
                  $(".pagetop").css("display", "none");
                } else {
                  $(".pagetop").css("display", "block");
                }

              });

            

            bindLoad( function () {
              if (location.hash !== "") {
                var targetOffset = safeTop($(location.hash));
                $(window).delay(1000).scrollTop(targetOffset);
              }
            });
      } catch (e) { console.warn('[LP] initHaircareLp block 13', e); }
    })();

    /* inview: 動的読込後も表示する */
    (function () {
      try {
        var $els = $('.inview');
        if (!$els.length) return;
        $els.each(function () {
          var $el = $(this);
          if ($el.data('lpInviewBound')) return;
          $el.data('lpInviewBound', 1);
          $el.one('inview', function (event, isInView) {
            if (isInView) $(this).stop().animate({ opacity: 1 }, 500);
          });
        });
        $(window).trigger('scroll');
      } catch (e) {}
    })();
  };

  window.destroyHaircareLp = function () {
    var $ = window.jQuery;
    if (!$) return;
    try {
      $(document).off('.lpHair');
      $('#hc .step-slider .slick-next, #hc .step-slider .slick-prev').off('click.lpHair');
      $('#hc .step-item-slider .slick-next--step2, #hc .step-item-slider .slick-prev--step2').off('click.lpHair');
      $('#hc .step-item-slider .slick-next--step3, #hc .step-item-slider .slick-prev--step3').off('click.lpHair');
      $('#hc .step-item-slider .slick-next--step4, #hc .step-item-slider .slick-prev--step4').off('click.lpHair');
      $('.slick-initialized').each(function () { $(this).slick('unslick'); });
    } catch (e) {}
    try {
      document.querySelectorAll('.swiper').forEach(function (el) {
        if (el.swiper) el.swiper.destroy(true, true);
      });
    } catch (e) {}
    $('.open-modal').off('click');
    $('.pagetop a').off('click');
  };
})();
